/* Importare come mixin di Vue per avere dei riferimenti alle icone di world */

export default {
  getWorldIcon(icon) {
    return {
      menuAnm22Logo: require("../../libs/anm22_icons/img/menu/anm22logo.png"),
      menuAnm22LogoExtended: require("../../libs/anm22_icons/img/menu/anm22logo-extended.png"),
      menuBeTasker: require("../../libs/anm22_icons/img/menu/betaskerlogo.png"),
      menuSpiagge: require("../../libs/anm22_icons/img/menu/spiagge-logo-yellow-square-small.png"),
      /* APPS Icons */
      workIcon: require("../../libs/anm22_icons/img/apps/app-work.png"),
      payIcon: require("../../libs/anm22_icons/img/apps/app-pay.png"),
      contactsIcon: require("../../libs/anm22_icons/img/apps/app-contacts.png"),
      foodIcon: require("../../libs/anm22_icons/img/apps/app-food.png"),
      payShopIcon: require("../../libs/anm22_icons/img/apps/app-pay-shop.png"),
      taskIcon: require("../../libs/anm22_icons/img/apps/app-tasks.png"),
      calendarIcon: require("../../libs/anm22_icons/img/apps/app-calendar.png"),
      yourbeachIcon: require("../../libs/anm22_icons/img/apps/app-yourbeach-2020.png"),
      resourceIcon: require("../../libs/anm22_icons/img/apps/app-rmbooking.png"),

      /* Default icons */
      userDefault: require("../../libs/anm22_icons/img/icons/user.png"),
      multiUser: require("../../libs/anm22_icons/img/icons/multi-user.png"),
      helpIcon: require("../../libs/anm22_icons/img/icons/help.svg"),
      privacyPolicy: require("../../libs/anm22_icons/img/icons/policy.svg"),
      workDefault: require("../../libs/anm22_icons/img/anm22_world/work.png"),
      fileDefault: require("../../libs/anm22_icons/img/icons/file.svg"),
      viewFull: require("../../images/icons/view_agenda_black.png"),
      viewGantt: require("../../images/icons/gantt.svg"),
      viewCols: require("../../images/icons/view_week_black.png"),
      viewLastEvents: require("../../libs/anm22_icons/img/icons/view_module_black.svg"),
      workMaterial: require("../../libs/anm22_icons/img/icons/work.svg"),
      workContact: require("../../libs/anm22_icons/img/icons/domain_outline.svg"),
      person: require("../../libs/anm22_icons/img/icons/person_outlined.svg"),
      userMaterial: require("../../libs/anm22_icons/img/icons/user.svg"),
      userFlat: require("../../libs/anm22_icons/img/icons/user-flat.svg"),
      /* Settings */
      settingsSet: require("../../libs/anm22_icons/img/icons/setting-set.png"),
      settingsVer: require("../../libs/anm22_icons/img/icons/setting-info.png"),
      settingsUser: require("../../libs/anm22_icons/img/icons/setting-user.png"),
      settingsPhoto: require("../../libs/anm22_icons/img/icons/setting-photo.png"),
      settingsPrinter: require("../../libs/anm22_icons/img/icons/setting-printer.png"),
      /* Buttons */
      add: require("../../libs/anm22_icons/img/icons/add.svg"),
      addWhite: require("../../libs/anm22_icons/img/icons/add_white_24px.svg"),
      addGreen: require("../../libs/anm22_icons/img/icons/add-green.png"),
      remove: require("../../libs/anm22_icons/img/icons/remove.svg"),
      removeWhite: require("../../libs/anm22_icons/img/icons/remove-white.svg"),
      edit: require("../../libs/anm22_icons/img/icons/edit_outline.svg"),
      deleteRed: require("../../libs/anm22_icons/img/icons/delete-red.png"),
      deleteBlack: require("../../libs/anm22_icons/img/icons/delete.svg"),
      deleteWhite: require("../../libs/anm22_icons/img/icons/delete-white.svg"),
      deleteBin: require("../../libs/anm22_icons/img/icons/delete_outline.svg"),
      deleteBinPng: require("../../libs/anm22_icons/img/icons/delete_outlined.png"),
      deleteBinWhite: require("../../libs/anm22_icons/img/icons/delete-bin-white.svg"),
      tick: require("../../libs/anm22_icons/img/icons/tick.png"),
      check: require("../../libs/anm22_icons/img/icons/check.svg"),
      checkBlue: require("../../libs/anm22_icons/img/icons/check-blue.svg"),
      maybe: require("../../libs/anm22_icons/img/icons/question-mark.svg"),
      questionMark: require("../../libs/anm22_icons/img/icons/question-mark.svg"),
      back: require("../../libs/anm22_icons/img/icons/back.svg"),
      /* Arrows */
      arrowUp: require("../../libs/anm22_icons/img/icons/arrow-up.png"),
      arrowDown: require("../../libs/anm22_icons/img/icons/arrow-down.png"),
      arrowLeft: require("../../libs/anm22_icons/img/icons/arrow-left.png"),
      arrowRight: require("../../libs/anm22_icons/img/icons/arrow-right.png"),
      arrowFullUp: require("../../libs/anm22_icons/img/icons/arrow_full_up.svg"),
      arrowFullDown: require("../../libs/anm22_icons/img/icons/arrow_full_down.svg"),
      arrowFullLeft: require("../../libs/anm22_icons/img/icons/arrow_full_left.svg"),
      arrowFullRight: require("../../libs/anm22_icons/img/icons/arrow_full_right.svg"),
      arrowFullUpWhite: require("../../libs/anm22_icons/img/icons/arrow_full_up_white.svg"),
      arrowFullDownWhite: require("../../libs/anm22_icons/img/icons/arrow_full_down_white.svg"),
      arrowFullLeftWhite: require("../../libs/anm22_icons/img/icons/arrow_full_left_white.svg"),
      arrowFullRightWhite: require("../../libs/anm22_icons/img/icons/arrow_full_right_white.svg"),
      doubleArrowDown: require("../../libs/anm22_icons/img/icons/double-arrow-down.svg"),
      doubleArrowUp: require("../../libs/anm22_icons/img/icons/double-arrow-up.svg"),
      arrowDownRight: require("../../libs/anm22_icons/img/icons/arrow-down-right.svg"),
      /* Headbar */
      menuMobile: require("../../libs/anm22_icons/img/icons/menu-mobile.svg"),
      menuLoginLight: require("../../libs/anm22_icons/img/menu_old/menuloginlight.png"),
      menuLogoutLight: require("../../libs/anm22_icons/img/menu_old/menulogoutlight.png"),
      menuProfileLight: require("../../libs/anm22_icons/img/menu_old/menuprofilelight.png"),
      holoApps: require("../../libs/anm22_icons/img/menu/holoapps.png"),
      holoMenu: require("../../libs/anm22_icons/img/menu/holomenu.png"),
      holoBack: require("../../libs/anm22_icons/img/menu/holobackbig.png"),
      apps: require("../../libs/anm22_icons/img/icons/apps_black.svg"),
      menu: require("../../libs/anm22_icons/img/icons/menu_black.svg"),
      /*Inbox */
      inbox: require("../../libs/anm22_icons/img/icons/inbox.svg"),
      drafts: require("../../libs/anm22_icons/img/icons/drafts.svg"),
      template: require("../../libs/anm22_icons/img/icons/template.svg"),
      spam: require("../../libs/anm22_icons/img/icons/spam.svg"),
      google: require("../../libs/anm22_icons/img/icons/google.png"),
      outlook: require("../../libs/anm22_icons/img/icons/outlook.png"),
      yahoo: require("../../libs/anm22_icons/img/icons/yahoo.png"),
      other: require("../../libs/anm22_icons/img/icons/other.svg"),
      aruba: require("../../libs/anm22_icons/img/icons/arubab.jpg"),

      /* Menu */
      menuAdmin: require("../../libs/anm22_icons/img/icons/outline-description.svg"),
      menuAnalytics: require("../../libs/anm22_icons/img/menu/analytics.svg"),
      menuAnalyticsOrange: require("../../libs/anm22_icons/img/menu/analytics-orange.svg"),
      menuBeach: require("../../libs/anm22_icons/img/menu/beach.svg"),
      menuBeachBlue: require("../../libs/anm22_icons/img/menu/beach-blue.svg"),
      menuCalendar: require("../../libs/anm22_icons/img/menu/calendar.svg"),
      menuCalendarRed: require("../../libs/anm22_icons/img/menu/calendar-red.svg"),
      menuRegister: require("../../libs/anm22_icons/img/menu/cassa.svg"),
      menuRegisterGrey: require("../../libs/anm22_icons/img/menu/cassa-grey.svg"),
      menuContacts: require("../../libs/anm22_icons/img/menu/contacts.svg"),
      menuContactsBlue: require("../../libs/anm22_icons/img/menu/contacts-blue.svg"),
      menuECommerce: require("../../libs/anm22_icons/img/menu/e-commerce.svg"),
      menuEditor: require("../../libs/anm22_icons/img/menu/editor.svg"),
      menuFood: require("../../libs/anm22_icons/img/menu/food.svg"),
      menuFoodYellow: require("../../libs/anm22_icons/img/menu/food-yellow.svg"),
      menuGallery: require("../../libs/anm22_icons/img/menu/gallery.svg"),
      menuHelp: require("../../libs/anm22_icons/img/menu/help.svg"),
      menuLogin: require("../../libs/anm22_icons/img/menu/login.svg"),
      menuMail: require("../../libs/anm22_icons/img/menu/mail.svg"),
      menuNews: require("../../libs/anm22_icons/img/menu/news.svg"),
      menuPreview: require("../../libs/anm22_icons/img/menu/preview.svg"),
      menuQrCode: require("../../libs/anm22_icons/img/menu/qrcode.svg"),
      menuResource: require("../../libs/anm22_icons/img/menu/resource.png"),
      menuResourceYellow: require("../../libs/anm22_icons/img/menu/resource-yellow.png"),
      menuSettings: require("../../libs/anm22_icons/img/menu/settings.svg"),
      menuSwitch: require("../../libs/anm22_icons/img/menu/switch.svg"),
      menuTable: require("../../libs/anm22_icons/img/menu/table.svg"),
      menuTableGreen: require("../../libs/anm22_icons/img/menu/table-green.svg"),
      menuTables: require("../../libs/anm22_icons/img/menu/tables.svg"),
      menuTablesBrown: require("../../libs/anm22_icons/img/menu/tables-brown.svg"),
      menuTasks: require("../../libs/anm22_icons/img/menu/tasks.svg"),
      menuTasksGreen: require("../../libs/anm22_icons/img/menu/tasks-green.svg"),
      menuWallet: require("../../libs/anm22_icons/img/menu/wallet.svg"),
      menuWalletBrown: require("../../libs/anm22_icons/img/menu/wallet-brown.svg"),
      menuWarehouse: require("../../libs/anm22_icons/img/menu/warehouse.svg"),
      menuWarehouseYellow: require("../../libs/anm22_icons/img/menu/warehouse-yellow.svg"),
      menuWeather: require("../../libs/anm22_icons/img/menu/weather.svg"),
      menuWeatherBlue: require("../../libs/anm22_icons/img/menu/weather-blue.svg"),
      menuWork: require("../../libs/anm22_icons/img/menu/work.svg"),
      menuAvailability: require("../../libs/anm22_icons/img/availability.png"),
      menuInbox: require("../../libs/anm22_icons/img/menu/inbox.svg"),
      menuCart: require("../../libs/anm22_icons/img/menu/cart.svg"),
      menuMenu: require("../../libs/anm22_icons/img/menu/menu.svg"),
      userAdminRemove: require("../../libs/anm22_icons/img/menu/user-admin-remove.png"),
      userAdminAdd: require("../../libs/anm22_icons/img/menu/user-admin-add.png"),
      /* Tasks Filters */

      /* Contacts */
      phone: require("../../libs/anm22_icons/img/icons/phone.svg"),
      phoneWhite: require("../../libs/anm22_icons/img/icons/phone-white.svg"),
      phoneDisabled: require("../../libs/anm22_icons/img/icons/phone-disabled.svg"),
      email: require("../../libs/anm22_icons/img/icons/mail_outline.svg"),
      birthday: require("../../libs/anm22_icons/img/icons/cake.svg"),
      facebook: require("../../libs/anm22_icons/img/icons/facebook.png"),
      facebookWhite: require("../../libs/anm22_icons/img/icons/facebook-white.svg"),
      mybusiness: require("../../libs/anm22_icons/img/icons/mybusiness.svg"),
      website: require("../../libs/anm22_icons/img/icons/website.svg"),
      sdi: require("../../libs/anm22_icons/img/icons/receipt_outline.svg"),
      vatCode: require("../../libs/anm22_icons/img/icons/receipt_outline.svg"),
      taxCode: require("../../libs/anm22_icons/img/icons/receipt_outline.svg"),
      agent: require("../../libs/anm22_icons/img/icons/agent.svg"),
      /*Resource */
      cutlery: require("../../libs/anm22_icons/img/icons/cutlery.svg"),
      map: require("../../libs/anm22_icons/img/icons/map.png"),
      waiting: require("../../libs/anm22_icons/img/icons/waiting.svg"),
      running: require("../../libs/anm22_icons/img/icons/running.svg"),
      barber: require("../../libs/anm22_icons/img/icons/content-cut.svg"),
      barberWhite: require("../../libs/anm22_icons/img/icons/content-cut_white.svg"),
      progressEvent: require("../../libs/anm22_icons/img/icons/progress.png"),
      walking: require("../../libs/anm22_icons/img/icons/walking.svg"),
      public: require("../../libs/anm22_icons/img/icons/public.svg"),
      hideImage: require("../../libs/anm22_icons/img/icons/hide-image.svg"),
      sort: require("../../libs/anm22_icons/img/icons/sort.svg"),
      airplane: require("../../libs/anm22_icons/img/icons/flight_outlined.svg"),
      airplaneWhite: require("../../libs/anm22_icons/img/icons/flight_white.svg"),
      airplaneMode: require("../../libs/anm22_icons/img/icons/airplanemode_active.svg"),
      airplaneModeWhite: require("../../libs/anm22_icons/img/icons/airplanemode_active_white.svg"),
      boat: require("../../libs/anm22_icons/img/icons/barcavela.svg"),
      dayIcon: require("../../libs/anm22_icons/img/icons/dayicon.svg"),
      halfDayIcon: require("../../libs/anm22_icons/img/icons/halfdayicon.svg"),
      hourIcon: require("../../libs/anm22_icons/img/icons/houricon.svg"),
      halfHourIcon: require("../../libs/anm22_icons/img/icons/halfhouricon.svg"),
      boatWhite: require("../../libs/anm22_icons/img/icons/barcavelaWhite.svg"),
      tennis: require("../../libs/anm22_icons/img/icons/sports-tennis.svg"),
      tennisWhite: require("../../libs/anm22_icons/img/icons/sports-tennis_white.svg"),
      volleyball: require("../../libs/anm22_icons/img/icons/sports-volleyball.svg"),
      volleyballWhite: require("../../libs/anm22_icons/img/icons/sports-volleyball_white.svg"),
      bike: require("../../libs/anm22_icons/img/icons/bicicletta.svg"),
      bikeWhite: require("../../libs/anm22_icons/img/icons/biciclettaWhite.svg"),
      bowls: require("../../libs/anm22_icons/img/icons/bocce.svg"),
      bowlsWhite: require("../../libs/anm22_icons/img/icons/bocceWhite.svg"),
      soccer: require("../../libs/anm22_icons/img/icons/sports-and-outdoors.svg"),
      soccerWhite: require("../../libs/anm22_icons/img/icons/sports-and-outdoors_white.svg"),
      canoe: require("../../libs/anm22_icons/img/icons/kayaking.svg"),
      canoeWhite: require("../../libs/anm22_icons/img/icons/kayaking_white.svg"),
      helicopter: require("../../libs/anm22_icons/img/icons/helicopter.svg"),
      helicopterWhite: require("../../libs/anm22_icons/img/icons/helicopter_white.svg"),
      van: require("../../libs/anm22_icons/img/icons/airport-shuttle.svg"),
      vanWhite: require("../../libs/anm22_icons/img/icons/airport-shuttle_white.svg"),
      car: require("../../libs/anm22_icons/img/icons/macchina.svg"),
      carWhite: require("../../libs/anm22_icons/img/icons/macchinaWhite.svg"),
      rowboat: require("../../libs/anm22_icons/img/icons/rowing.svg"),
      rowboatWhite: require("../../libs/anm22_icons/img/icons/rowing_white.svg"),
      jetSki: require("../../libs/anm22_icons/img/icons/motoacqua.svg"),
      jetSkiWhite: require("../../libs/anm22_icons/img/icons/motoacquaWhite.svg"),
      motorBoat: require("../../libs/anm22_icons/img/icons/motoscafo.svg"),
      motorBoatWhite: require("../../libs/anm22_icons/img/icons/motoscafoWhite.svg"),
      pedalo: require("../../libs/anm22_icons/img/icons/pedalo.svg"),
      pedaloWhite: require("../../libs/anm22_icons/img/icons/pedaloWhite.svg"),
      pingPong: require("../../libs/anm22_icons/img/icons/pingpong.svg"),
      pingPongWhite: require("../../libs/anm22_icons/img/icons/pingpongWhite.svg"),
      meetingRoom: require("../../libs/anm22_icons/img/icons/meeting-room.svg"),
      meetingRoomWhite: require("../../libs/anm22_icons/img/icons/meeting-room_white.svg"),
      scooter: require("../../libs/anm22_icons/img/icons/moped.svg"),
      scooterWhite: require("../../libs/anm22_icons/img/icons/moped_white.svg"),
      surf: require("../../libs/anm22_icons/img/icons/surf.svg"),
      surfWhite: require("../../libs/anm22_icons/img/icons/surfWhite.svg"),
      resTable: require("../../libs/anm22_icons/img/icons/tavolo.svg"),
      resTableWhite: require("../../libs/anm22_icons/img/icons/tavoloWhite.svg"),
      shower: require("../../libs/anm22_icons/img/icons/shower.svg"),
      showerWhite: require("../../libs/anm22_icons/img/icons/showerWhite.svg"),
      motorsport: require("../../libs/anm22_icons/img/icons/sports-motorsports.svg"),
      sportsScore: require("../../libs/anm22_icons/img/icons/sports-score.svg"),
      // PayPal
      paypalLogo: require("../../libs/anm22_icons/img/icons/paypal_logo.png"),
      // Stripe
      stripeLogo: require("../../libs/anm22_icons/img/icons/stripe_logo.svg"),
      stripeConnectButton: require("../../libs/anm22_icons/img/icons/stripe_connect_button.png"),
      stripePoweredBy: require("../../libs/anm22_icons/img/icons/powered_by_stripe.svg"),

      /* FOOD Payment */
      paymentCash: require("../../libs/anm22_icons/img/icons/cash.png"),
      paymentCreditCard: require("../../libs/anm22_icons/img/icons/creditCard.png"),
      paymentDebitCard: require("../../libs/anm22_icons/img/icons/debitCard.png"),
      paymentYbAccount: require("../../libs/anm22_icons/img/apps/app-spiagge.png"),
      paymentSpiaggeAccount: require("../../libs/anm22_icons/img/apps/app-spiagge.png"),
      paymentPay: require("../../libs/anm22_icons/img/icons/contactless.svg"),
      paymentTransfer: require("../../libs/anm22_icons/img/icons/bank.svg"),
      paymentCheck: require("../../libs/anm22_icons/img/icons/bank-check.svg"),
      paymentSatispay: require("../../libs/anm22_icons/img/icons/satispay.svg"),
      /* Delivery */
      table: require("../../libs/anm22_icons/img/icons/table.svg"),
      pickUpRestaurant: require("../../libs/anm22_icons/img/icons/pickUpRestaurant.svg"),
      pickUpBar: require("../../libs/anm22_icons/img/icons/pickUpBar.svg"),
      pickUpChiringuito: require("../../libs/anm22_icons/img/icons/pickUpChiringuito.svg"),
      pickUpPoint: require("../../libs/anm22_icons/img/icons/pickUpPoint.svg"),
      delivery: require("../../libs/anm22_icons/img/icons/local_shipping_outlined.svg"),
      beachUmbrella: require("../../libs/anm22_icons/img/icons/beachUmbrella.svg"),
      beachUmbrellaWithCover: require("../../libs/anm22_icons/img/icons/beachUmbrellaWithCover.svg"),
      hotel: require("../../libs/anm22_icons/img/icons/hotel.svg"),
      contactStatus: require("../../libs/anm22_icons/img/icons/contact-status.svg"),
      room: require("../../libs/anm22_icons/img/icons/hotel.svg"),
      homeDelivery: require("../../libs/anm22_icons/img/icons/home-delivery.svg"),
      bungalow: require("../../libs/anm22_icons/img/icons/bungalow.svg"),
      /* Receipts */
      receipt: require("../../libs/anm22_icons/img/icons/print-receipt.svg"),
      invoice: require("../../libs/anm22_icons/img/icons/print-invoice.svg"),
      /* Markers */
      markerFood: require("../../../world/libs/anm22_icons/img/markers/marker-food.png"),
      markerBar: require("../../../world/libs/anm22_icons/img/markers/marker-bar.png"),
      markerRestaurant: require("../../../world/libs/anm22_icons/img/markers/marker-restaurant.png"),
      /* Misc */
      stackedLineChart: require("../../libs/anm22_icons/img/icons/stacked-line-chart.svg"),
      abandoned: require("../../libs/anm22_icons/img/icons/exit.svg"),
      flightLand: require("../../libs/anm22_icons/img/icons/flight-land.svg"),
      flightOff: require("../../libs/anm22_icons/img/icons/flight-off.svg"),
      beachSize: require("../../libs/anm22_icons/img/icons/beach-size.svg"),
      gpsPlace: require("../../libs/anm22_icons/img/icons/gps-place.svg"),
      scanBlack: require("../../libs/anm22_icons/img/icons/app-scan-black.png"),
      textMsg: require("../../libs/anm22_icons/img/icons/textmsg.png"),
      shareFeed: require("../../libs/anm22_icons/img/icons/share.svg"),
      expandBoard: require("../../libs/anm22_icons/img/icons/expand.png"),
      resizeBoard: require("../../libs/anm22_icons/img/icons/resize.png"),
      offline: require("../../libs/anm22_icons/img/icons/offline.svg"),
      offlineWhite: require("../../libs/anm22_icons/img/icons/offline-white.svg"),
      spinner: require("../../libs/anm22_icons/img/gif/loading.gif"),
      time: require("../../libs/anm22_icons/img/icons/time.svg"),
      timer: require("../../libs/anm22_icons/img/icons/timer.svg"),
      place: require("../../libs/anm22_icons/img/icons/marker-square.png"),
      placeBlack: require("../../libs/anm22_icons/img/icons/place_outline.svg"),
      placeWhite: require("../../libs/anm22_icons/img/icons/place-white.svg"),
      lock: require("../../libs/anm22_icons/img/icons/lock.svg"),
      unLock: require("../../libs/anm22_icons/img/icons/unlock.svg"),
      rmPlanning: require("../../libs/anm22_icons/img/icons/cell.png"),
      zoomcell: require("../../libs/anm22_icons/img/icons/zoomcell.png"),
      card: require("../../libs/anm22_icons/img/icons/credit-card.svg"),
      marker: require("../../libs/anm22_icons/img/icons/marker.png"),
      pinToTop: require("../../libs/anm22_icons/img/icons/pinToTop.png"),
      pinToTopOff: require("../../libs/anm22_icons/img/icons/pinToTopOff.png"),
      zoomIn: require("../../libs/anm22_icons/img/icons/zoomin.svg"),
      zoomOut: require("../../libs/anm22_icons/img/icons/zoomout.svg"),
      linkTable: require("../../libs/anm22_icons/img/icons/linktable.svg"),
      movePrenotation: require("../../libs/anm22_icons/img/icons/move.svg"),
      notConfirmed: require("../../libs/anm22_icons/img/icons/notconfirmed.svg"),
      smartphone: require("../../libs/anm22_icons/img/icons/smartphone.svg"),
      noshow: require("../../libs/anm22_icons/img/icons/noshow.svg"),
      closed: require("../../libs/anm22_icons/img/icons/closed.svg"),
      runningTable: require("../../libs/anm22_icons/img/icons/eating.svg"),
      money: require("../../libs/anm22_icons/img/icons/money.png"),
      link: require("../../libs/anm22_icons/img/icons/link.svg"),
      linkOff: require("../../libs/anm22_icons/img/icons/link_off.svg"),
      play: require("../../libs/anm22_icons/img/icons/play-arrow.svg"),
      playWhite: require("../../libs/anm22_icons/img/icons/play-arrow-white.svg"),
      pause: require("../../libs/anm22_icons/img/icons/pause.svg"),
      dash: require("../../libs/anm22_icons/img/icons/dash.svg"),
      priorityHighest: require("../../libs/anm22_icons/img/icons/priority-highest.svg"),
      priorityHigh: require("../../libs/anm22_icons/img/icons/priority-high.svg"),
      priorityMedium: require("../../libs/anm22_icons/img/icons/priority-medium.svg"),
      priorityLow: require("../../libs/anm22_icons/img/icons/priority-low.svg"),
      priorityLowest: require("../../libs/anm22_icons/img/icons/priority-lowest.svg"),
      folder: require("../../libs/anm22_icons/img/icons/folder.png"),
      folderMaterial: require("../../libs/anm22_icons/img/icons/folder.svg"),
      qrCode: require("../../libs/anm22_icons/img/icons/qrcode.svg"),
      tShirtBlack: require("../../libs/anm22_icons/img/icons/t-shirt-black.svg"),
      ruler: require("../../libs/anm22_icons/img/icons/ruler.svg"),
      list: require("../../libs/anm22_icons/img/icons/list.svg"),
      messenger: require("../../libs/anm22_icons/img/icons/messenger.svg"),
      listWhite: require("../../libs/anm22_icons/img/icons/list_white.svg"),
      grid: require("../../libs/anm22_icons/img/icons/grid.svg"),
      shippingTruck: require("../../libs/anm22_icons/img/icons/local_shipping_outlined.svg"),
      scissors: require("../../libs/anm22_icons/img/icons/content-cut.svg"),
      sewingMachine: require("../../libs/anm22_icons/img/icons/sewing-machine.svg"),
      stars: require("../../libs/anm22_icons/img/icons/stars.svg"),
      searchLeft: require("../../libs/anm22_icons/img/icons/search-left.png"),
      searchLeftWhite: require("../../libs/anm22_icons/img/icons/search-left-white.svg"),
      searchRight: require("../../libs/anm22_icons/img/icons/search-right.png"),
      printer: require("../../libs/anm22_icons/img/icons/printer.svg"),
      send: require("../../libs/anm22_icons/img/icons/send.svg"),
      chat: require("../../libs/anm22_icons/img/icons/chat.svg"),
      whatsapp: require("../../libs/anm22_icons/img/icons/whatsapp.svg"),
      linkedin: require("../../libs/anm22_icons/img/icons/linkedin.png"),
      twitter: require("../../libs/anm22_icons/img/icons/x.png"),
      instagram: require("../../libs/anm22_icons/img/icons/instagram.png"),
      chatWhite: require("../../libs/anm22_icons/img/icons/chat-white.svg"),
      openApp: require("../../libs/anm22_icons/img/icons/open.png"),
      open: require("../../libs/anm22_icons/img/icons/open.svg"),
      xeLogo: require("../../libs/anm22_icons/img/icons/xe-logo.png"),
      mega: require("../../libs/anm22_icons/img/icons/mega.png"),
      discord: require("../../libs/anm22_icons/img/icons/discord.svg"),
      googleDrive: require("../../libs/anm22_icons/img/icons/google-drive.png"),
      googleMyBusiness: require("../../libs/anm22_icons/img/icons/google-my-business.png"),
      googleForms: require("../../libs/anm22_icons/img/icons/google-forms.png"),
      googleSlides: require("../../libs/anm22_icons/img/icons/google-slides.png"),
      googleSheets: require("../../libs/anm22_icons/img/icons/google-sheets.png"),
      googleDocs: require("../../libs/anm22_icons/img/icons/google-docs.png"),
      googleMeet: require("../../libs/anm22_icons/img/icons/google-meet.png"),
      youtube: require("../../libs/anm22_icons/img/icons/youtube.svg"),
      zoomLogo: require("../../libs/anm22_icons/img/icons/zoomLogo.png"),
      hangouts: require("../../libs/anm22_icons/img/icons/hangouts.svg"),
      skype: require("../../libs/anm22_icons/img/icons/skype.png"),
      icloud: require("../../libs/anm22_icons/img/icons/icloud.png"),
      slack: require("../../libs/anm22_icons/img/icons/slack.svg"),
      microsoftTeams: require("../../libs/anm22_icons/img/icons/microsoft-teams.png"),
      dropbox: require("../../libs/anm22_icons/img/icons/dropbox.svg"),
      bitbucket: require("../../libs/anm22_icons/img/icons/bitbucket.svg"),
      github: require("../../libs/anm22_icons/img/icons/github.png"),
      openWhite: require("../../libs/anm22_icons/img/icons/open_white.svg"),
      tag: require("../../libs/anm22_icons/img/icons/tag.svg"),
      runningMan: require("../../libs/anm22_icons/img/icons/running_man.svg"),
      sheet: require("../../libs/anm22_icons/img/icons/sheet.svg"),
      printInvoice: require("../../libs/anm22_icons/img/icons/print-invoice.svg"),
      walletBlack: require("../../libs/anm22_icons/img/icons/wallet_black.svg"),
      printf: require("../../libs/anm22_icons/img/icons/printf.png"),
      print: require("../../libs/anm22_icons/img/icons/print.png"),
      cash: require("../../libs/anm22_icons/img/icons/cash.svg"),
      bancomat: require("../../libs/anm22_icons/img/icons/bancomat.png"),
      creditCard: require("../../libs/anm22_icons/img/icons/creditCard.png"),
      ybAccount: require("../../libs/anm22_icons/img/icons/ybAccount.png"),
      shoppingCart: require("../../libs/anm22_icons/img/icons/shopping-cart.svg"),
      emptyCart: require("../../libs/anm22_icons/img/icons/empty-cart.svg"),
      stop: require("../../libs/anm22_icons/img/icons/pan-tool.svg"),
      stopWhite: require("../../libs/anm22_icons/img/icons/pan-tool-white.svg"),
      mediaPlay: require("../../libs/anm22_icons/img/icons/play.svg"),
      mediaPlayWhite: require("../../libs/anm22_icons/img/icons/play_white.svg"),
      mediaStop: require("../../libs/anm22_icons/img/icons/stop.svg"),
      mediaStopWhite: require("../../libs/anm22_icons/img/icons/stop_white.svg"),
      logs: require("../../libs/anm22_icons/img/icons/logs.svg"),
      copy: require("../../libs/anm22_icons/img/icons/copy.svg"),
      download: require("../../libs/anm22_icons/img/icons/download.svg"),
      downloadWhite: require("../../libs/anm22_icons/img/icons/download-white.svg"),
      upload: require("../../libs/anm22_icons/img/icons/upload.svg"),
      sync: require("../../libs/anm22_icons/img/icons/sync.svg"),
      syncWhite: require("../../libs/anm22_icons/img/icons/sync-white.svg"),
      listAdd: require("../../libs/anm22_icons/img/icons/list-add.svg"),
      split: require("../../libs/anm22_icons/img/icons/split.svg"),
      save: require("../../libs/anm22_icons/img/icons/save.svg"),
      visibilityOff: require("../../libs/anm22_icons/img/icons/visibility-off.svg"),
      done: require("../../libs/anm22_icons/img/icons/done.svg"),
      dragHandle: require("../../libs/anm22_icons/img/icons/drag-handle.svg"),
      admin: require("../../libs/anm22_icons/img/icons/admin.svg"),
      event: require("../../libs/anm22_icons/img/icons/event.svg"),
      reminder: require("../../libs/anm22_icons/img/icons/reminder.svg"),
      reminderWhite: require("../../libs/anm22_icons/img/icons/reminder_white.svg"),
      filter: require("../../libs/anm22_icons/img/icons/filter.png"),
      filterList: require("../../libs/anm22_icons/img/icons/filter_list.svg"),
      filterListWhite: require("../../libs/anm22_icons/img/icons/filter_list_white.svg"),
      abacus: require("../../libs/anm22_icons/img/icons/abacus.svg"),
      contract: require("../../libs/anm22_icons/img/icons/contract.svg"),
      mailbox: require("../../libs/anm22_icons/img/icons/mailbox.svg"),
      monitor: require("../../libs/anm22_icons/img/icons/monitor.svg"),
      importExport: require("../../libs/anm22_icons/img/icons/import_export.svg"),
      importExportWhite: require("../../libs/anm22_icons/img/icons/import_export_white.svg"),
      importWhite: require("../../libs/anm22_icons/img/icons/import_white.svg"),
      registerWhite: require("../../libs/anm22_icons/img/icons/register_white.svg"),
      drawer: require("../../libs/anm22_icons/img/icons/drawer.svg"),
      drawerWhite: require("../../libs/anm22_icons/img/icons/drawer_white.svg"),
      info: require("../../libs/anm22_icons/img/icons/info.svg"),
      umbrellaAdd: require("../../libs/anm22_icons/img/icons/umbrella_add.svg"),
      foodAdd: require("../../libs/anm22_icons/img/icons/food_add.svg"),
      warning: require("../../libs/anm22_icons/img/icons/warning.svg"),
      warningRed: require("../../libs/anm22_icons/img/icons/warning-red.svg"),
      chromeWebStore: require("../../libs/anm22_icons/img/icons/chrome-web-store.png"),
      history: require("../../libs/anm22_icons/img/icons/history_black.svg"),
      sprint: require("../../libs/anm22_icons/img/icons/sprint.svg"),
      group: require("../../libs/anm22_icons/img/icons/group_outline.svg"),
      questionAnswerFilled: require("../../libs/anm22_icons/img/icons/question_answer_filled.svg"),
      flight: require("../../libs/anm22_icons/img/icons/flight_outlined.svg"),
      flightWhite: require("../../libs/anm22_icons/img/icons/flight_white.svg"),
      refresh: require("../../libs/anm22_icons/img/icons/refresh_outlined.svg"),
      refreshWhite: require("../../libs/anm22_icons/img/icons/refresh_outlined_white.svg"),
      eventBusy: require("../../libs/anm22_icons/img/icons/event-busy_outlined.svg"),
      photoCamera: require("../../libs/anm22_icons/img/icons/photo_camera_black.svg"),
      package: require("../../libs/anm22_icons/img/icons/package_2_outlined.svg"),
      home: require("../../libs/anm22_icons/img/icons/home_outlined.svg"),
      ticket: require("../../libs/anm22_icons/img/icons/confirmation-number.svg"),
      confirmationNumber: require("../../libs/anm22_icons/img/icons/confirmation-number.svg"),
      beachAccess: require("../../libs/anm22_icons/img/icons/beach-access_outlined.svg"),
      beachAccessPng: require("../../libs/anm22_icons/img/icons/beach-access_outlined.png"),
      mouse: require("../../libs/anm22_icons/img/icons/mouse.svg"),
      mouseWhite: require("../../libs/anm22_icons/img/icons/mouse_white.svg"),
      headphones: require("../../libs/anm22_icons/img/icons/headphones.svg"),
      headphonesWhite: require("../../libs/anm22_icons/img/icons/headphones_white.svg"),
      computer: require("../../libs/anm22_icons/img/icons/computer.svg"),
      computerWhite: require("../../libs/anm22_icons/img/icons/computer_white.svg"),
      key: require("../../libs/anm22_icons/img/icons/key_outlined.svg"),
      keyOff: require("../../libs/anm22_icons/img/icons/key-off_outlined.svg"),
      bracelet: require("../../libs/anm22_icons/img/icons/fitness-tracker.svg"),

      /* Logos */
      logosBeTasker: require("../../libs/anm22_icons/img/logos/betasker.png"),
      logosCoristech: require("../../libs/anm22_icons/img/logos/coristech.jpg"),
      logosCustom: require("../../libs/anm22_icons/img/logos/custom.png"),
      logosEpson: require("../../libs/anm22_icons/img/logos/epson.jpg"),
      logosItalretail: require("../../libs/anm22_icons/img/logos/italretail.jpg"),
      logosRch: require("../../libs/anm22_icons/img/logos/rch.jpg"),
    }[icon];
  },
};
